import React from 'react'
import Slider from 'react-slick'
import { Card } from 'react-bootstrap'
import imageNotFound from 'src/images/imageNotFound.png'
import './styles.scss'
import { Link } from 'react-router-dom'
import { pageNames } from 'src/routes/pathParams'

const ProductSlider = ({ items, onShowMore }) => {
  let slidesToShow = 5
  if (window.innerWidth < 768) {
    slidesToShow = Math.min(items.length, 3)
  }
  if (window.innerWidth < 480) {
    slidesToShow = Math.min(items.length, 2)
  }
  if (window.innerWidth < 375) {
    slidesToShow = Math.min(items.length, 1)
  }

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: Math.min(items.length, 3),
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: Math.min(items.length, 3),
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: Math.min(items.length, 3),
        },
      },
    ],
  }

  return (
    <div className="product-slider">
      <Slider {...settings}>
        {items.map(item => {
          if (item.isShowMore) {
            return (
              <div key="show-more" className="show-more-container">
                <button
                  data-test-id="qa-show-more-btn"
                  className="show-more-btn"
                  onClick={onShowMore}
                  tabIndex={0}
                  role="button"
                  aria-label={`Show ${item.count} more bundles`}
                  onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      onShowMore()
                    }
                  }}>
                  +{item.count}
                </button>
              </div>
            )
          }
          return (
            <div key={item.id} className="bundle-item-wrapper">
              <Link
                to={
                  pageNames.product +
                  '/' +
                  (item?.properties?.slug || item?.identifier)
                }
                className="image-container-wrap"
                id={`product_card_img_${item.id}`}
                target="_blank"
                rel="noopener noreferrer"
                data-test-id={`qa-bundle-item-link-${item?.identifier}`}>
                <Card className="bundle-item-card">
                  <div className="bundle-image-container">
                    <Card.Img
                      variant="top"
                      src={item.imageUrl}
                      alt={item.name}
                      className="bundle-item-image"
                      onError={e => {
                        e.target.src = imageNotFound
                      }}
                    />
                  </div>
                  <Card.Body className="bundle-item-body">
                    <Card.Text className="bundle-item-price">
                      {item.formattedPrice}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Link>
            </div>
          )
        })}
      </Slider>
    </div>
  )
}

export default ProductSlider
